import styled from "styled-components";

export const StyledSimpleButton = styled.button`
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 5px;
  border: 1px solid black;
  border-radius: 5px;
  font-weight: bold;

  &:hover {
    background-color: #ffffff;
    cursor: pointer;
  }

  img {
    height: 18px;
    width: auto;
  }
`;
